import { useRef } from "react";
import { ArrowBack, ArrowDropDown, NavigateNext } from "@mui/icons-material";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import { Apply } from "../apply/Apply";
import PkCommonArrow from "../../../components/common/PkCommonArrow";
function TheHeader({ show }) {
  return (
    <>
      <Typography variant="h6" sx={{ pr: 2.25 }}>
        {show.name}
      </Typography>
      <Box sx={{ pt: 1, pb: 3, display: "flex" }}>
        <Box
          sx={{
            mt: 0.75,
            height: "40px",
            borderLeft: 2,
            borderColor: "primary.main",
            opacity: 0.75,
          }}
        ></Box>
        <Box>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ pl: 2.5, lineHeight: 1.75 }}
          >
            {show.text}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: (theme) => theme.palette.grey[600],
              pl: 2.5,
              lineHeight: 1.75,
            }}
          >
            {show.type}
          </Typography>
        </Box>
      </Box>
    </>
  );
}
function TheFeature() {
  const [show, setShow] = React.useState(null);
  const ref0 = useRef(null);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  return (
    <Box ref={ref2} sx={{ pb: "4rem" }}>
      {show ? (
        <Box ref={ref0} data-aos="fade-left" data-aos-offset="100">
          <Card
            key={`${show.name}`}
            sx={{
              height: "100%",
              backgroundColor: (theme) => theme.palette.grey[900],
            }}
          >
            <Grid container>
              <Grid item xs={12} md={6}>
                <CardMedia
                  sx={{
                    maxHeight: `450px`,
                    borderBottom: 1,
                    borderColor: `#444`,
                  }}
                  component="img"
                  image={show.image}
                  src={show.image}
                  alt={show.name}
                />
                {/* <CardActions sx={{ pt: `2rem` }}>
                  <IconButton
                    sx={{ ml: 3 }}
                    onClick={() => {
                      ref0.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(null);
                        setTimeout(function () {
                          ref1.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }}
                  >
                    <ArrowBack
                      sx={{ color: "primary.main", fontSize: `1.75rem` }}
                    />
                  </IconButton>
                </CardActions> */}
                <CardContent sx={{ px: "2.5rem", pt: `2.5rem`, pb: 2 }}>
                  <TheHeader show={show} />
                </CardContent>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  borderLeft: 1,
                  borderColor: `#333`,
                }}
              >
                <CardContent sx={{ p: "0 2.5rem 0" }}>
                  <Box sx={{ textAlign: `center`, mt: -6, height: `100px` }}>
                    <ArrowDropDown
                      sx={{
                        color: `primary.main`,
                        fontSize: "7rem",
                      }}
                    />
                  </Box>
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    sx={{ lineHeight: 2 }}
                  >
                    {show.info}
                  </Typography>
                </CardContent>
                <CardActions sx={{ py: `2rem`, pt: `1rem` }}>
                  <IconButton
                    sx={{ ml: 3 }}
                    onClick={() => {
                      ref0.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(null);
                        setTimeout(function () {
                          ref1.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }}
                  >
                    <ArrowBack
                      sx={{ color: "primary.main", fontSize: `1.75rem` }}
                    />
                  </IconButton>
                </CardActions>
              </Grid>
            </Grid>
          </Card>
        </Box>
      ) : (
        <Box ref={ref1} data-aos="fade-right">
          {HELP.map((s) => (
            <Card
              key={`${s.name}`}
              sx={{
                mb: 10,
                height: "100%",
                backgroundColor: (theme) => theme.palette.grey[900],
              }}
            >
              <CardMedia
                sx={{ maxHeight: `384px` }}
                component="img"
                image={s.banner}
                src={s.banner}
                alt={s.name}
              />
              <CardContent sx={{ p: "2.5rem 2.5rem 0" }}>
                <TheHeader show={s} />
              </CardContent>
              <CardActions>
                <Button
                  endIcon={<NavigateNext />}
                  sx={{
                    mb: 2,
                    ml: 3,
                    px: 0,
                    backgroundColor: "transparent",
                    color: "primary.main",
                    "&:hover": {
                      backgroundColor: "transparent",
                      color: "white",
                    },
                  }}
                  onClick={() => {
                    setTimeout(function () {
                      ref1.current.classList.remove("aos-animate");
                      setTimeout(function () {
                        setShow(s);
                        setTimeout(function () {
                          ref2.current.scrollIntoView();
                          ref0.current.classList.add("aos-animate");
                        }, 300);
                      }, 300);
                    }, 100);
                  }}
                >
                  LEARN MORE
                </Button>
              </CardActions>
            </Card>
          ))}
          <Box
            sx={{ p: `4rem 0 8rem`, display: "flex", justifyContent: "center" }}
          >
            <PkCommonArrow color={(theme) => `primary.main`} />
          </Box>
          <Apply />
        </Box>
      )}
    </Box>
  );
}
export function Featured() {
  return (
    <Box sx={{ backgroundColor: "white", p: `10rem 5% 5rem` }}>
      <TheFeature />
    </Box>
  );
}
const HELP = [
  {
    banner:
      "https://website-img.polycaik.com/w/asset/network/banner_xyioc4.jpg",
    image: "https://website-img.polycaik.com/w/asset/network/image_xyioc4.jpg",
    name: "Sam Hook",
    type: "MUSIC | SOUND EFFECTS",
    text: "Grammy Nominated hit songwriter Samuel “Sam Hook” Jean",
    info: "Grammy Nominated hit songwriter Samuel “Sam Hook” Jean was born in Brooklyn, New York. Throughout his career, Hook has worked with artists such as Miley Cyrus, Trey Songz, Chris Brown, Rae Sremmurd, Justin Beiber, DJ Khaled, SEEB, YG, ScHoolboy Q, Remy MA, Ella Mai, French Montana, Mary J. Blige, SWV, Boyz II Men, K-pop Group EXO, Why Don’t We, DJ Mustard, Mike Will Made It, Teyana Taylor, Jordin Sparks, and August Alsina etc. Hook is known for writing on hits such as “Pot of Gold” by rapper The Game, “Booty” by International megastar Jennifer Lopez, Omarion’s #1 hit single “Post To Be”, songs on Miley Cyrus’s hit album Bangerz, and the majority of the songs on the Trey Songz album Trigga which included #1 single “Na Na”. In addition, Hook holds 4 ASCAP Awards, Contributions to 5 Grammy-nominated albums, numerous RIAA Certified Platinum and Multi Platinum singles and albums, and Billboard Rhythmic #1 singles. Hook also founded the record company, The Family Business Enterprises LLC. Today, he continues to follow the same foundation of hard work that he learned from his parents and he continues to innovate and grow all while keeping it in the family.",
  },
  {
    banner:
      "https://website-img.polycaik.com/w/asset/network/banner_jkf45r.jpg",
    image: "https://website-img.polycaik.com/w/asset/network/image_jkf45r.jpg",
    name: "Iyare Oronsaye",
    type: "CG GENERAL | ANIMATION",
    text: "Digital artist, director, and animator",
    info: "Iyare Oronsaye is a digital artist, director, and animator who has worked on a range of projects within the production industry. He has experience both as a traditional artist working from hand-drawn animation and as a digital artist working on 3D and motion capture projects. His work has been exhibited and broadcast throughout the United States including the Discovery Channel, Telly, Netflix, The Spectrum Theatre, Hirshhorn Museum and Sculpture Garden, SPACE Art Center, Fashion Week MN, Maryland State House, Bradley University, Smithsonian's National Zoo, UNISYS, Henninger's Media, Chemical Education Foundation, PBS, North Wood Advertising, Lifetime Fitness, Gasket Arts, and the National Children's Museum. Iyare also has experience teaching a variety of multimedia courses. Course topics over the years have included basic coding for MEL and Python, visual effects, character animation, 3D modeling, character rigging, rendering for production, drawing, character design, storyboarding, and game design. He is currently an Assistant Professor at the University of Northwestern where he co-developed and maintains the Animation and Illustration program under the Department of Art & Design.",
  },
];
